// extracted by mini-css-extract-plugin
export default {"cls1":"NwPxORqx_JTspOsSetK3","cls2":"TJJSkBO6kS5FBuN8zfns NwPxORqx_JTspOsSetK3"};